import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailActionClockBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "email-action-clock" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.5,9.5a7.908,7.908,0,0,1,3.151.657A.251.251,0,0,0,21,9.927V1.75a.158.158,0,0,0-.1-.147.16.16,0,0,0-.173.034L12.2,10.164a2.407,2.407,0,0,1-3.4,0L.271,1.637A.159.159,0,0,0,0,1.75v10.5A1.749,1.749,0,0,0,1.75,14h8.413a.252.252,0,0,0,.223-.136A8,8,0,0,1,17.5,9.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.726,9.236a1.094,1.094,0,0,0,1.547,0L19.748.761A.437.437,0,0,0,19.5.019,1.62,1.62,0,0,0,19.249,0H1.749A1.62,1.62,0,0,0,1.5.019a.434.434,0,0,0-.351.3.439.439,0,0,0,.1.447Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm0,11A4.5,4.5,0,1,1,22,17.5,4.505,4.505,0,0,1,17.5,22Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M19.5,16.75h-1a.25.25,0,0,1-.25-.25V15a.75.75,0,0,0-1.5,0v2.5a.75.75,0,0,0,.75.75h2a.75.75,0,0,0,0-1.5Z" })
	]
});
export default SvgEmailActionClockBold;
